import ComponentManager from '../shared/component-manager';

import AttachmentReloader from './components/group/attachment-reloader';
import GroupMessage from './components/group/group-message';
import GroupMessageFormToggle from './components/group-message-form-toggle';
import GroupMessages from './components/group/group-messages';
import GroupSelect from './components/group/group-select';
import GroupsSearch from './components/group/groups-search';
import GroupsTable from './components/group/groups-table';
import GroupSuggestions from './components/group/group-suggestions';
import MentionableTextarea from './components/group/mentionable-textarea';

class GroupComponentManager extends ComponentManager {
  initializeComponents() {
    AttachmentReloader.initialize('.groupMessage-attachment--unextracted');
    GroupMessage.initialize('.groupMessage');
    GroupMessageFormToggle.initialize('.groupMessageForm-wrapper');
    GroupMessages.initialize('.groupMessages');
    GroupSelect.initialize('.groupsList');
    GroupsSearch.initialize('.groupsSearch');
    GroupsTable.initialize('.groupsTable');
    GroupSuggestions.initialize('.groupSuggestions');
    MentionableTextarea.initialize('.mentionableTextarea');
  }
}

export const initialize = () => {
  jQuery(() => {
    new GroupComponentManager([
      AttachmentReloader,
      GroupMessage,
      GroupMessageFormToggle,
      GroupMessages,
      GroupSelect,
      GroupsSearch,
      GroupsTable,
      GroupSuggestions,
    ]);
  });
};
